module.exports = __webpack_public_path__ + "media/images/lb/549-db533195a152af645c96f54d68ae4061.svg";